<template>
  <div>
    <div style='height:50px;'></div>
    <el-row :gutter="20">
      <el-col :span="6" :offset="6">
        <el-button type="primary" icon="el-icon-document"
                   @click='download'>步骤1. 下载标准模板</el-button>
      </el-col>
      <el-col :span="6" :pull='2'>
        <el-button type="success" icon="el-icon-upload"
                   @click='download'>步骤2. 上传已填好的模板</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    download() {
      // console.log(212)
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/web/human_affairs/import/list.vue